<template>
    <v-card flat class="pie-chart-card-root"> 
      <v-card-title class="chart-title-area">
        <v-icon
          medium
          left
          >
         {{icon}}
        </v-icon>
        <span class="gray-font">{{data_chart.title}}</span>
      </v-card-title>
      <v-card-text class="chart-content-area">
       <apexchart 
          type="pie" 
          :height="'100%'" 
          ref="chart"
          :options="chartOptions" 
          :series="series" 
          class="chart-wrapper">
       </apexchart>
      </v-card-text>
    </v-card>
</template>

<script>
export default {

  name: 'PieChart',
  props: ['width','height_chart','height_card','data_chart','icon'],

  data () {
    return {
    	series: [44, 55, 13, 43, 22],
      chartOptions: {
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: [],
        
        legend:{
        	position: 'bottom',
        	horizontalAlign: 'center', 
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          offsetY: 0,
          style: {
              fontSize: '13px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 'bold',
              colors: ['white']
          },
          formatter: function (val, opts) {
            if (val > 8){
              return val.toFixed(1)+'%'
            }
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -10
            },
            /* 🔥 CAMBIO CLAVE: Reduce el tamaño del círculo interno al 90% */
            customScale: 0.7,
          }
        },
      },
    }
  },
  mounted(){
  	this.updateChart();
  },
  computed:{
  	updateData(){
  		this.data_chart;
  	}
  },
  watch:{
  	data_chart: {
      handler() {
        this.updateChart();
      },
      deep: true, // Permite detectar cambios profundos en el objeto data_chart
    },
  },
  methods:{
  	updateChart(){
      let position_legend;
      
      if( this.height_card <= 200){
        position_legend = 'bottom';
      }
      else{
        position_legend = 'right';
      }

  		this.$refs.chart.updateOptions({
  			series:this.data_chart.serie,
  			labels: this.data_chart.categories,
  			colors:this.data_chart.colors,
        legend:{
          position: position_legend
        }
  		});
  	}
  }
}
</script>

<style lang="css" scoped>
div.chart-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/* 1. Contenedor Raíz: Asegura que la v-card use el 100% del espacio del Cuadrante 3 */
.pie-chart-card-root {
  height: 100%;
  display: flex;
  flex-direction: column; /* Organiza título y contenido verticalmente */
  padding: 0; /* Vuetify añade padding a v-card por defecto, lo quitamos */
}
/* 2. Área del Título: Se mantiene fijo y no se encoge */
.chart-title-area {
  flex-shrink: 0; 
  padding: 8px 16px 0 16px !important; /* Estilo de título más limpio */
}
/* 3. Área de Contenido (v-card-text): Absorbe todo el espacio restante */
.chart-content-area {
  flex: 1; /* 🏆 ¡CLAVE! Ocupa el espacio vertical restante */
  min-height: 0; /* Permite que el contenido se ajuste */
  padding: 0 !important; /* Restaura padding solo al contenido */
}
/* 4. Wrapper del Gráfico: Asegura que el gráfico use el 100% del alto */
div.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; /* Ocupa el 100% del chart-content-area */
}
/* Ajuste específico para el texto del título */
.gray-font {
  color: #555; /* Asegurando un color de título estético */
  font-weight: 600;
  font-size: 1rem;
}
</style>